import PropTypes from 'prop-types';
import React from 'react';

import Button from 'common/components/Button';
import FollowButton from 'common/components/FollowButton';
import Hover from 'common/components/Hover';
import noop from 'common/tools/noop';
import trans from 'common/tools/translations/trans';

const defaultUnfollowText = trans(
  'userspace.my-community.user-card.stopFollowing'
);
const defaultFollowedText = trans('userspace.my-community.user-card.followed');

const FollowUnfollowButton = ({
  size,
  isFollowed,
  follow,
  unfollow,
  unfollowButtonTheme,
  unfollowButtonType,
  followButtonTheme,
  followButtonType,
  unfollowText,
  followedText,
  followText
}) => {
  return isFollowed ? (
    <Hover forceHoverOnTouchDevices={false}>
      {({ isHovered }) => {
        const theme = isHovered ? 'danger' : unfollowButtonTheme;
        return (
          <Button
            theme={theme}
            type={unfollowButtonType}
            size={size}
            onClick={() => unfollow()}
            className={!isHovered ? 'icon icon-tick' : null}
          >
            {isHovered ? unfollowText : followedText}
          </Button>
        );
      }}
    </Hover>
  ) : (
    <FollowButton
      theme={followButtonTheme}
      type={followButtonType}
      onClick={() => follow()}
    >
      {followText}
    </FollowButton>
  );
};

FollowUnfollowButton.propTypes = {
  size: PropTypes.string,
  isFollowed: PropTypes.bool.isRequired,
  follow: PropTypes.func,
  unfollow: PropTypes.func,
  unfollowButtonTheme: PropTypes.string,
  unfollowButtonType: PropTypes.string,
  followButtonType: PropTypes.string,
  followButtonTheme: PropTypes.string,
  followText: PropTypes.string,
  unfollowText: PropTypes.string,
  followedText: PropTypes.string
};

FollowUnfollowButton.defaultProps = {
  size: 'sm',
  follow: noop,
  unfollow: noop,
  unfollowButtonTheme: 'white',
  unfollowButtonType: 'ghost',
  followButtonTheme: 'inverse',
  followButtonType: 'ghost',
  followText: undefined,
  unfollowText: defaultUnfollowText,
  followedText: defaultFollowedText
};

export default FollowUnfollowButton;
